import {observer} from 'mobx-react-lite'
import React from 'react'
import {ChartData} from '@components/common/base/table/types'
import {
  TwColumn,
  TwColumnChart,
  TwColumnInner,
  TwColumnsWrapper,
  TwColumnTitleInner,
  TwColumnTitles
} from '@components/statistics/by-time/columns-chart/containers'

interface ColumnsChartProps {
  chartData: {
    className?: string
    data: ChartData[]
  }
}

export const ColumnsChart = observer(
  ({chartData}: ColumnsChartProps): JSX.Element => {
    return (
      <TwColumnChart className={chartData.className}>
        <TwColumnsWrapper>
          {chartData.data.map(column => {
            return (
              <TwColumn key={column.id}>
                <TwColumnInner
                  style={{
                    height: `${column.percentage}%`,
                    backgroundColor: column.color
                  }}
                />
              </TwColumn>
            )
          })}
        </TwColumnsWrapper>
        <TwColumnTitles>
          {chartData.data.map(column => {
            return (
              <TwColumnTitleInner key={column.id}>
                {column.title}
              </TwColumnTitleInner>
            )
          })}
        </TwColumnTitles>
      </TwColumnChart>
    )
  }
)
